import { services } from "../config/services";
import { customFetch } from "../customFetch";

export const licenses = {
  getLicenses: (companyId: string, page = 1, pageSize = 30) =>
    customFetch(
      `${services.licenses}?CompanyId=${companyId}&PageNumber=${page}&PageSize=${pageSize}`,
    ),
  getLicense: (licenseId: string) =>
    customFetch(`${services.licenses}/${licenseId}`),
};
